module.exports = __webpack_public_path__ + "static/joonsung-c481ec921ee0bf5da82739eedb16ba85.jpeg";